// extracted by mini-css-extract-plugin
export default {"card":"DZ-z","carouselContainer":"EZ-z","carouselContent":"FZ-z"};